import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useProducts() {
  const q = useQuery({
    queryKey: ["products"],
    queryFn: async () => {
      if (!process.env.REACT_APP_BACKEND_URL) return [];
      const res = await api.get("/products");
      return Array.isArray(res.data) ? res.data : [];
    },
  });
  return { products: q.data ?? [], isLoading: q.isLoading, isError: q.isError };
}
